<template>
    <div class="sign-body"
         ref="content">
        <div class="sign-title"
             :style="headerStyle">
            请绘制清晰可辨的签名
            <template v-if="!isPCSignPage">
                <div class="anticon close-btn"
                     @click="closeSetSign"></div>
            </template>
        </div>
        <div class="board">
            <canvas class="sign-canvas"
                    ref="myCanvas"
                    @touchstart="writeStart"
                    @touchend="writeEnd"
                    @touchmove="writeMove"></canvas>
        </div>
        <div class="sign-footer"
             :style="footerStyle">
            <div class="inline fl"
                 style="width:140px;">
                <i class="anticon"
                   :class="{blue:lineWidth=='tiny'}"
                   @click="changeWidth('tiny')">&#xe70e;</i>
                <i class="anticon"
                   :class="{blue:lineWidth=='medium'}"
                   @click="changeWidth('medium')">&#xe70f;</i>
                <i class="anticon"
                   :class="{blue:lineWidth=='large'}"
                   @click="changeWidth('large')">&#xe710;</i>
            </div>
            <div class="horizon-center">
                <button class="clear"
                        @click="clear">清除</button>
                <button :class="{'save-disabled':!isWriteStart,'save':isWriteStart}"
                        @disabled="!isWriteStart"
                        @click="save">保存</button>
            </div>
            <div class="inline fr"
                 style="position:relative;height:100%;">
                <div @click="changePenColor('red')"
                     :class="{'outer-circle':penColor=='red'}"
                     class="red circle  vertical-center"
                     style="right:16px;"></div>
                <div @click="changePenColor('blue')"
                     :class="{'outer-circle':penColor=='blue'}"
                     class="blue circle  vertical-center"
                     style="right:60px;"></div>
                <div @click="changePenColor('black')"
                     :class="{'outer-circle':penColor=='black'}"
                     class="black circle  vertical-center"
                     style="right:106px;"></div>
            </div>
        </div>
    </div>
</template>

<script>
import SignaturePad from './model';

export default {
    props: {
        pageFrom: {
            type: String
        }
    },
    data () {
        return {
            bodyHeight: '',
            signaturePad: '',
            lineWidth: 'medium',
            penColor: 'black',
            isWriteStart: false,// 是否开始手写
        };
    },
    created: function () { },
    computed: {
        headerStyle () {
            return {
                width: this.bodyHeight + 1.5 + 'px',
                right: 23.5 - this.bodyHeight / 2 + 'px',
                top: this.bodyHeight / 2 - 25 + 'px'
            };
        },
        footerStyle () {
            return {
                width: this.bodyHeight + 'px',
                left: 24 - this.bodyHeight / 2 + 'px',
                top: this.bodyHeight / 2 - 26 + 'px'
            };
        },
        isPCSignPage () {
            return this.pageFrom != 'user';
        }
    },
    mounted: function () {
        const canvas = this.$refs.myCanvas;
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        let canvasCxt = canvas.getContext('2d');
        canvasCxt.scale(ratio, ratio);
        this.signaturePad = new SignaturePad(canvas);
        this.bodyHeight = this.$refs.content.offsetHeight;
        this.signaturePad.penColor = '#273039';
        this.signaturePad.minWidth = 2;
        this.signaturePad.maxWidth = 2;
    },
    methods: {
        changePenColor (color) {
            switch (color) {
            case 'black':
                this.signaturePad.penColor = '#273039';
                break;
            case 'blue':
                this.signaturePad.penColor = '#409eff';
                break;
            case 'red':
                this.signaturePad.penColor = '#f74555';
                break;
            default:
            }
            this.penColor = color;
        },
        changeWidth (type) {
            switch (type) {
            case 'tiny':
                this.signaturePad.minWidth = 1;
                this.signaturePad.maxWidth = 1;
                break;
            case 'medium':
                this.signaturePad.minWidth = 2;
                this.signaturePad.maxWidth = 1;
                break;
            case 'large':
                this.signaturePad.minWidth = 2.5;
                this.signaturePad.maxWidth = 2.5;
                break;
            default:
            }
            this.lineWidth = type;
        },
        writeStart (e) {
            this.isWriteStart = true;
            this.signaturePad._handleTouchStart(e);
        },
        writeMove (e) {
            this.signaturePad._handleTouchMove(e);
        },
        writeEnd: function (e) {
            this.signaturePad._handleTouchEnd(e);
        },
        save () {
            if (this.signaturePad.isEmpty()) {
                // this.$toast('签名不能为空！');
                return;
            }
            const data = this.signaturePad.toDataURL('image/png', 0.3);
            this.$emit('saveSignature', data);
        },
        clear () {
            this.isWriteStart = false;
            this.signaturePad.clear();
        },
        closeSetSign: function () {
            if (this.pageFrom === 'user') {
                history.go(-1);
            }
        },
        convertBase64UrlToBlob: function (urlData) {
            const bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte

            //处理异常,将ascii码小于0的转换为大于0
            let ab = new ArrayBuffer(bytes.length);
            let ia = new Uint8Array(ab);
            for (let i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
            return new Blob([ab], { type: 'image/png' });
        }
    }
};
</script>


<style scoped lang="less">
@base-color: #409eff;
@grey-color: #e5e5e5;
@confirm-btn-color: #CBB486;

.btn-style {
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
}

.sign-body {
    position: absolute;
    font-size: 10px;
    border: 1px solid #e8e8e8;
    background-color: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.27),
        0 0 40px rgba(0, 0, 0, 0.08) inset;
    border-radius: 4px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
    margin: 0;
    z-index: 999;
}

.board {
    position: absolute;
    left: 50px;
    right: 50px;
    top: 0;
    bottom: 0;

    canvas {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border: none;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.02) inset;
        border: none;
    }
}

.sign-footer {
    transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    position: absolute;
    height: 50px;
    border-top: 1px dashed #e5e7ea;

    .circle {
        display: inline-block;
        width: 22px;
        height: 22px;
        border-radius: 100%;
        line-height: 50px;
        &.outer-circle:before {
            position: absolute;
            top: -4px;
            right: -4px;
            content: "";
            opacity: 0.2;
            width: 30px;
            height: 30px;
            border-radius: 100%;
            display: inline-block;
        }
        &.black {
            background: #273039;
            &.outer-circle:before {
                background: #273039;
            }
        }
        &.blue {
            background: @base-color;
            &.outer-circle:before {
                background: @base-color;
            }
        }
        &.red {
            background: #f74555;
            &.outer-circle:before {
                background: #f74555;
            }
        }
    }
    .anticon {
        font-size: 30px;
        line-height: 51px;
        margin-left: 10px;
        color: #c0c0c0;
        &:first-child {
            margin-left: 10px;
        }
        &.blue {
            color: @base-color;
        }
    }
    button {
        height: 36px;
        font-size: 16px;
        width: 80px;
    }
    .clear:extend(.btn-style) {
        background-color: #fff;
        border: 1px solid @confirm-btn-color;
        line-height: 36px;
        color: @confirm-btn-color;
        margin: 5px;
    }
    .save:extend(.btn-style) {
        background-color: @confirm-btn-color;
        border: 1px solid @confirm-btn-color;
        margin-left: 40px;
        line-height: 36px;
        color: #fff;
        margin: 5px;
    }
    .save-disabled:extend(.btn-style) {
        background-color: @grey-color;
        border: 1px solid @grey-color;
        margin-left: 40px;
        line-height: 36px;
        color: rgba(0, 0, 0, 0.3);
        margin: 5px;
    }
}

.sign-title {
    transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    position: absolute;
    height: 50px;
    text-align: center;
    line-height: 3;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    background-color: #fff;
    border-bottom: 1px solid #e5e5e5;
    color: #000;
    .photo {
        color: white;
        position: absolute;
        line-height: 50px;
        left: 20px;
        font-size: 13px;
    }
    .close-btn {
        float: right;
        font-size: 1.5em;
        margin-right: 10px;
        line-height: 2;

        &:before {
            content: "\E600";
            color: #fff;
        }
    }
}
</style>
